import { jsx as e, jsxs as a } from "react/jsx-runtime";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { l as k, m as S, D as U } from "../../index-DVHhaa_b.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import { assessment as L } from "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { useAppState as V } from "../../context/app/index.js";
import { Legend as M, LegendItem as O } from "../legend/index.js";
import { prettyDate as R } from "../../helpers/dates.js";
import { getColorForIndex as v } from "../../helpers/strings.js";
import { DaymapSkeleton as W } from "../skeletons/index.js";
import { Alert as q, AlertTitle as z, Stack as G, Button as w, Grid as j, Box as J, FormControl as T, Select as N, MenuItem as f, FormLabel as K, RadioGroup as X, FormControlLabel as x, Radio as P, Switch as Z, Typography as E } from "@mui/material";
import { ScheduleCalendar as _ } from "./ScheduleCalendar.js";
function Re({ studentId: s, onTaskClick: d, classCode: c, dateRange: y, courseId: p }) {
  const [l, n] = V("StudentAssessmentSchedule", {
    classCode: "",
    taskType: "",
    colorBy: "class",
    selectedTaskId: void 0,
    startFromToday: !0,
    showDueDateOnly: !1
  }, "session"), { data: r, isPending: m, error: o } = new L.TasksForStudent({
    studentId: Number(s),
    classCode: c || "",
    allPublished: !1,
    dateRange: y || L.AssessmentTaskListDateRange.ThisYear,
    courseId: p
  }).ToQuery(), { classCode: D, taskType: u, colorBy: C, selectedTaskId: F, startFromToday: A, showDueDateOnly: Y } = l;
  if (m)
    return /* @__PURE__ */ e(W, { type: "listitems" });
  if (o)
    return /* @__PURE__ */ a(q, { children: [
      o.title && /* @__PURE__ */ e(z, { children: o.title }),
      o.detail
    ] });
  const g = r.filter((t, i) => r.findIndex((h) => h.Type === t.Type) === i).map((t) => t.Type), I = r.filter((t, i) => r.findIndex((h) => h.ClassCode === t.ClassCode) === i).map((t) => ({ code: t.ClassCode, name: t.ClassName })), b = c ? "type" : C, B = c ? "" : D, H = r.filter((t) => (B === "" || t.ClassCode === B) && (u === "" || t.Type === u)).map((t) => {
    let i = b === "type" ? g.indexOf(t.Type) : I.findIndex((h) => h.code === t.ClassCode);
    return {
      id: t.ID,
      start: Y ? t.DueDate : t.SetDate,
      end: t.DueDate,
      title: t.Name,
      color: v(i),
      onClick: () => n({ ...l, selectedTaskId: t.ID })
    };
  });
  let Q = (/* @__PURE__ */ new Date()).getMonth();
  return /* @__PURE__ */ a(G, { gap: 2, justifyContent: "center", children: [
    F && /* @__PURE__ */ e(ee, { ...r.find((t) => t.ID === F), onClose: () => n({ ...l, selectedTaskId: void 0 }), onTaskClick: d }),
    /* @__PURE__ */ e($, { classes: I, types: g, state: { ...l, colorBy: b }, onChange: n, hideClassControls: !!c }),
    b === "type" ? /* @__PURE__ */ e(M, { title: "Task Types", children: g.map((t, i) => /* @__PURE__ */ e(O, { color: v(i), label: t }, t)) }) : /* @__PURE__ */ e(M, { title: "Classes", children: I.map((t, i) => /* @__PURE__ */ e(O, { color: v(i), label: t.name }, t.name)) }),
    A && Q > 0 ? /* @__PURE__ */ e(w, { startIcon: /* @__PURE__ */ e(k, { iconType: S.ChevronDown }), sx: { alignSelf: "center" }, onClick: () => n({ ...l, startFromToday: !1 }), children: "Show previous months" }) : /* @__PURE__ */ e(w, { startIcon: /* @__PURE__ */ e(k, { iconType: S.ChevronUp }), sx: { alignSelf: "center" }, onClick: () => n({ ...l, startFromToday: !0 }), children: "Hide previous months" }),
    /* @__PURE__ */ e(_, { startMonthIndex: A ? (/* @__PURE__ */ new Date()).getMonth() : 0, year: (/* @__PURE__ */ new Date()).getFullYear(), items: H })
  ] });
}
const $ = ({ state: s, onChange: d, classes: c, types: y, hideClassControls: p = !1 }) => {
  const { classCode: l, colorBy: n, taskType: r, showDueDateOnly: m } = s;
  return /* @__PURE__ */ a(J, { display: "flex", gap: 3, p: 2, flexWrap: "wrap", children: [
    !p && /* @__PURE__ */ e(T, { children: /* @__PURE__ */ a(
      N,
      {
        labelId: "classList-label",
        id: "classList",
        value: l,
        onChange: (o) => d({ ...s, classCode: o.target.value }),
        displayEmpty: !0,
        sx: { width: 160 },
        children: [
          /* @__PURE__ */ e(f, { value: "", children: "All Classes" }),
          c.map((o) => /* @__PURE__ */ e(f, { value: o.code, children: o.name }, o.code))
        ]
      }
    ) }),
    /* @__PURE__ */ e(T, { children: /* @__PURE__ */ a(
      N,
      {
        labelId: "taskType-label",
        id: "taskType",
        value: r,
        onChange: (o) => d({ ...s, taskType: o.target.value }),
        displayEmpty: !0,
        sx: { width: 160 },
        children: [
          /* @__PURE__ */ e(f, { value: "", children: "All Task Types" }),
          y.map((o) => /* @__PURE__ */ e(f, { value: o, children: o }, o))
        ]
      }
    ) }),
    !p && /* @__PURE__ */ a(T, { children: [
      /* @__PURE__ */ e(K, { id: "color-by-label", children: "Colour by" }),
      /* @__PURE__ */ a(X, { row: !0, "aria-labelledby": "color-by-label", name: "color-by", value: n, onChange: (o) => d({ ...s, colorBy: o.target.value }), children: [
        /* @__PURE__ */ e(x, { value: "class", control: /* @__PURE__ */ e(P, {}), label: "Class" }),
        /* @__PURE__ */ e(x, { value: "type", control: /* @__PURE__ */ e(P, {}), label: "Task Type" })
      ] })
    ] }),
    /* @__PURE__ */ e(T, { children: /* @__PURE__ */ e(x, { checked: m, control: /* @__PURE__ */ e(Z, { onChange: (o) => d({ ...s, showDueDateOnly: o.target.checked }) }), label: "Show due date only", labelPlacement: "end" }) })
  ] });
}, ee = ({ ClassName: s, ID: d, Name: c, SetDate: y, DueDate: p, TeacherName: l, Type: n, onClose: r, onTaskClick: m }) => {
  const o = (D, u, C = { xs: 6, sm: 6 }) => /* @__PURE__ */ a(j, { size: C, children: [
    /* @__PURE__ */ e(E, { variant: "caption", children: D }),
    /* @__PURE__ */ e(E, { variant: "body2", children: u })
  ] });
  return /* @__PURE__ */ e(U, { open: !0, onClose: r, children: /* @__PURE__ */ a(G, { p: 2, gap: 2, alignItems: "center", children: [
    /* @__PURE__ */ a(j, { container: !0, spacing: 2, children: [
      o("Task", c, { xs: 12, sm: 6 }),
      o("Type", n, { xs: 12, sm: 6 }),
      o("Class", s),
      o("Teacher", l),
      o("Set Date", R(y)),
      o("Due Date", R(p))
    ] }),
    /* @__PURE__ */ e(w, { onClick: () => m == null ? void 0 : m(d), startIcon: /* @__PURE__ */ e(k, { iconType: S.Assessment }), children: "View Task" })
  ] }) });
};
export {
  Re as AssessmentSchedule
};
//# sourceMappingURL=AssessmentSchedule.js.map
